import React from 'react';
import Icon from '../../../components/AppIcon';
import { format } from 'date-fns';

const ConversationHistory = ({ 
  conversations, 
  currentConversationId, 
  onSelectConversation, 
  onDeleteConversation 
}) => {
  return (
    <div className="h-full flex flex-col">
      <div className="p-4 border-b border-border">
        <h3 className="font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="History" size={20} className="text-primary" />
          Conversation History
        </h3>
      </div>
      
      <div className="flex-1 overflow-y-auto p-2">
        {conversations?.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            <Icon name="MessageSquare" size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">No conversations yet</p>
          </div>
        ) : (
          <div className="space-y-1">
            {conversations?.map((conversation) => (
              <div
                key={conversation?.conversation_id}
                className={`group relative p-3 rounded-lg cursor-pointer transition-colors ${
                  conversation?.conversation_id === currentConversationId
                    ? 'bg-primary/10 border border-primary' :'hover:bg-muted border border-transparent'
                }`}
                onClick={() => onSelectConversation?.(conversation?.conversation_id)}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground truncate">
                      {conversation?.title || 'Untitled Conversation'}
                    </p>
                    <p className="text-xs text-muted-foreground mt-1">
                      {format(new Date(conversation?.updated_at), 'MMM dd, yyyy')}
                    </p>
                  </div>
                  <button
                    onClick={(e) => {
                      e?.stopPropagation();
                      onDeleteConversation?.(conversation?.conversation_id);
                    }}
                    className="opacity-0 group-hover:opacity-100 p-1 hover:bg-error/10 rounded transition-opacity"
                    aria-label="Delete conversation"
                  >
                    <Icon name="Trash2" size={14} className="text-error" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ConversationHistory;